import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ClientSite } from 'src/app/models/clientsite';
import { DefaultSiteSelectionInfo, SitePermissionInfo } from 'src/app/my-hospital-users/my-hospital-user.model';

@Component({
    selector: 'app-site-permission-viewer',
    templateUrl: './site-permission-viewer.component.html',
    styleUrls: ['./site-permission-viewer.component.scss']
})
export class SitePermissionViewerComponent implements OnInit, OnDestroy, OnChanges {
    sitesWithPermission = new BehaviorSubject<SitePermissionInfo[]>([]);
    sitesNoPermission = new BehaviorSubject<SitePermissionInfo[]>([]);

    @Input()
    permittedSiteIds: number[] = [];

    @Input()
    allSites: ClientSite[] = [];

    @Input()
    defaultSite: number | null;

    @Input()
    triggerSitesRefresh: EventEmitter<void>;

    @Output()
    defaultSiteChanged = new EventEmitter<DefaultSiteSelectionInfo>();

    subscriptions = new Subscription();

    constructor() {}

    ngOnInit() {
        this.initSitesWithPermission(this.allSites, this.permittedSiteIds);

        if (this.triggerSitesRefresh) {
            this.subscriptions.add(
                this.triggerSitesRefresh.subscribe(_ => {
                    this.initSitesWithPermission(this.allSites, this.permittedSiteIds);
                })
            );
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        const allSites = changes.allSites?.currentValue ?? this.allSites;
        const permittedSiteIds = changes.permittedSiteIds?.currentValue ?? this.permittedSiteIds;

        this.initSitesWithPermission(allSites, permittedSiteIds);
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    initSitesWithPermission(allSites: ClientSite[], permittedSiteIds: number[]) {
        const isOrgLevel = permittedSiteIds?.[0] === null && permittedSiteIds?.length === 1;

        const newSitesPermission = allSites
            ?.sort((siteA, siteB) => (siteA.siteName.localeCompare(siteB.siteName) < 0 ? -1 : 1))
            .map(site => new SitePermissionInfo(isOrgLevel || (permittedSiteIds?.includes(site.siteId) ?? false), site));

        this.sitesWithPermission.next(newSitesPermission.filter(item => item.isPermitted));
        this.sitesNoPermission.next(newSitesPermission.filter(item => !item.isPermitted));
    }

    setDefaultSite(site: SitePermissionInfo, isDefault: boolean) {
        this.defaultSiteChanged.emit(new DefaultSiteSelectionInfo(site.siteInfo.siteId, isDefault));
    }
}
